import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import RaceResultsTable from "../DataTables/RaceResultsTable";

import moment from "moment";
import firebase from "firebase/app";
import "firebase/database";

const styles = theme => ({
  downloadLink: {
    textDecoration: "none"
  },
  cardHeader: {
    backgroundColor: theme.palette.white
  },
  avatar: {
    backgroundColor: theme.palette.secondary.color["500"]
  },
  media: {
    height: 520
  },
  card: {
    backgroundColor: theme.palette.white
  }
});

class RaceResultsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelectChange = event => {
    this.setState({ loading: true, lastEventDate: event.target.value }, () =>
      firebase
        .database()
        .ref("races/" + this.state.lastEventDate)
        .once("value")
        .then(race => {
          if (!race.val()) {
            return;
          }
          this.setState({
            lastEventResultsTableData: race.val().parsedResults,
            lastEventStats: race.val().stats,
            lastEventDate: moment(race.key, "YYYY-MM-DD").format(
              "MMMM DD, YYYY"
            ),
            loading: false
          });
        })
    );
  };

  render() {
    const { classes } = this.props;
    const lastEventDate = this.state.lastEventDate
      ? this.state.lastEventDate
      : this.props.lastEventDate;
    const lastEventResultsTableData = this.state.lastEventResultsTableData
      ? this.state.lastEventResultsTableData
      : this.props.lastEventResultsTableData;

    return (
      <Card className={classes.card}>
        <CardHeader
          title={<i>Last event results</i>}
          className={classes.cardHeader}
        />

        <CardContent className={classes.cardContent}>
          {this.state.loading ? (
            <CircularProgress />
          ) : (
            <RaceResultsTable
              title={
                <div>
                  <FormControl className={classes.formControl}>
                    <Select
                      value={moment(lastEventDate, "MMMM DD, YYYY").format(
                        "YYYY-MM-DD"
                      )}
                      onChange={this.handleSelectChange}
                    >
                      {this.props.timedRaceDates.map(date => (
                        <MenuItem value={date} key={date}>
                          {moment(date, "YYYY-MM-DD").format("MMMM DD, YYYY")}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              }
              data={lastEventResultsTableData}
            />
          )}
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(RaceResultsCard);
